// Local library
import { AccountFacade } from '@amwager/account/data-access';
import { WagerFacade } from '@amwager/wager/data-access';
import { UnsubscribeObservableService } from '@amwager/util';

//Angular
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  NgZone,
  OnInit
} from '@angular/core';
import { CommonModule } from '@angular/common';

// Third party
import { combineLatest, takeUntil } from 'rxjs';
import * as _ from 'lodash';

// Ionic
import { AlertController } from '@ionic/angular/standalone';

@Component({
  selector: 'feature-ion-favorite-tracks',
  templateUrl: './favorite-tracks.component.html',
  styleUrls: ['./favorite-tracks.component.scss'],
  imports: [
    CommonModule,
  ],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FavoriteTracksComponent extends UnsubscribeObservableService implements OnInit {

  tabList!: HTMLElement[];
  unSelectedTracks: boolean = true;
  favoriteTracks: boolean = false;

  listOfFavorites: any[] = [];
  allAvailableEvents: any[] = [];
  // allAvailableEventsCopy: any[] = [];

  favoriteEvents: any[] = [];
  untrackedEvents: any[] = [];
  favoriteEventsCopy: any[] = [];
  untrackedEventsCopy: any[] = [];

  iSelectedEvents!: HTMLElement[];
  selectedEvents: any[] = [];

  isProcessing: boolean = false;
  isDisabled: boolean = false;
  typeTriggered: string = 'unselected-track';

  constructor(
    private readonly accountFacade: AccountFacade,
    private readonly wagerFacade: WagerFacade,
    private readonly alertCtrl: AlertController,
    private elementRef: ElementRef,
    private readonly ngZone: NgZone,
    private readonly cdRef: ChangeDetectorRef
  ) {
    super();

  }

  ngOnInit() {
    this.wagerFacade.getAllEventsNameAndId('FavoriteTracksComponent:ngOnInit');
    this.accountFacade.getAccountPreferencesAPI();

    const events = this.wagerFacade.getAllEventsNameAndId$();
    const preferences = this.accountFacade.isGetAccountPreferencesSuccess$();

    combineLatest([events, preferences])
      .pipe(takeUntil(this.toUnsubscribe$))
      .subscribe(([events, preferences]) => {

        // console.log(events);
        // console.log(preferences);

        if (
          events?.isSuccess === undefined ||
          preferences?.isSuccess === undefined
        ) return;

        const eventsResponse = events?.response;
        this.allAvailableEvents = eventsResponse?.AllAvailableEvents;

        const preferencesResponse = preferences?.response?.AccountPreferences;
        this.listOfFavorites = preferencesResponse?.ListOfFavorites;

        // render lists
        this.favoriteEvents = this.allAvailableEvents.filter(
          item => this.listOfFavorites.includes(item.EventId)
        );
        this.untrackedEvents = this.allAvailableEvents.filter(
          item => !this.listOfFavorites.includes(item.EventId)
        );

        this.favoriteEventsCopy = this.favoriteEvents;
        this.untrackedEventsCopy = this.untrackedEvents;

        if (this.isProcessing) {

          this.isProcessing = false;

          if (this.typeTriggered === 'unselected-track'){
            this.unSelectedTracks = true;
            this.favoriteTracks = false;
            this.currentTab('unselected');
          }
          else {
            this.unSelectedTracks = false;
            this.favoriteTracks = true;
            this.currentTab('favorite');
          }
        }

        this.cdRef.markForCheck();
      });
  }

  currentTab(type: string): void {
    this.tabList = this.elementRef.nativeElement.querySelectorAll(
      '.unselected-favorite-row p.active'
    );
    _.forEach(this.tabList, (html: HTMLElement) => {
      html.classList.remove('active');
    });

    const currentTab = this.elementRef.nativeElement.querySelector('.'+type+' p');
    currentTab.classList.add('active');
  }

  unSelectedTrackTab($event: any): void {
    this.unSelectedTracks = true;
    this.favoriteTracks = false;

    this.currentTab('unselected');

    this.selectedEvents = [];
  }

  favoriteTrackTab($event: any): void {
    this.unSelectedTracks = false;
    this.favoriteTracks = true;

    this.currentTab('favorite');

    this.selectedEvents = [];
  }

  onSearch($event: any, type: boolean) {
    // const searchTerm = (event.target as HTMLInputElement).value.toLowerCase();
    const searchTerm = $event.target.value;
    if (
      searchTerm === undefined ||
      !this.untrackedEventsCopy.length ||
      !this.favoriteEventsCopy.length
    ) return;

    // this.allAvailableEvents = this.allAvailableEventsCopy.filter(
    //   item => item.EventName.toLowerCase().includes(searchTerm.toLowerCase())
    // );

    if (!type) {
      this.untrackedEvents = this.untrackedEventsCopy.filter(
        item => item.EventName.toLowerCase().includes(searchTerm.toLowerCase())
      );
    } else {
      this.favoriteEvents = this.favoriteEventsCopy.filter(
        item => item.EventName.toLowerCase().includes(searchTerm.toLowerCase())
      );
    }
  }

  addEvent(): void {
    if (!this.selectedEvents.length || this.isProcessing) return;

    this.isProcessing = true;

    this.listOfFavorites = _.uniq([...this.listOfFavorites, ...this.selectedEvents]);

    this.accountFacade.upsertAccountPrefenceFieldAPI(
      'ListOfFavorites',
      JSON.stringify(this.listOfFavorites)
    );

    this.selectedEvents = [];
    this.typeTriggered = 'favorite-track';
  }

  refreshSelectedEvents(): void {
    if (!this.selectedEvents.length || this.isProcessing) return;

    this.iSelectedEvents = this.elementRef.nativeElement.querySelectorAll(
      '.favorite-tracks-screen div.event-row i'
    );
    _.forEach(this.iSelectedEvents, (html: HTMLElement) => {
      if (html.classList.contains('active'))
        html.classList.remove('active');
    });

    this.selectedEvents = [];
  }

  clearFavoriteEvents(): void {
    if (!this.listOfFavorites.length) return;

    this.showAlertMessage(
      'Please Confirm! Are you sure you wish to remove all tracks from your favorite list?'
    );
  }

  doClearFavoriteEvents(): void {
    if (this.isProcessing) return;
    this.isProcessing = true;

    this.accountFacade.upsertAccountPrefenceFieldAPI(
      'ListOfFavorites',
      JSON.stringify([])
    );

    this.typeTriggered = 'unselected-track';
  }

  removeEvent($event: any, eventId: string): void {
    // stop parent func. trigger
    $event.stopPropagation();

    if (this.isProcessing) return;
    this.isProcessing = true;

    this.listOfFavorites = [...this.listOfFavorites];
    this.listOfFavorites = _.remove(this.listOfFavorites, id => id !== eventId);

    this.accountFacade.upsertAccountPrefenceFieldAPI(
      'ListOfFavorites',
      JSON.stringify(this.listOfFavorites)
    );

    this.typeTriggered = 'unselected-track';
  }

  selectEvent($event: any, eventId: string, index: number): void {
    if (this.isDisabled) return;
    this.isDisabled = true;

    // const event = $event.target as HTMLElement;
    const toggle = this.elementRef.nativeElement.querySelector('i#toggle-'+index);
    if (toggle === undefined) return;

    if (toggle.classList.contains('active'))
      toggle.classList.remove('active');
    else
      toggle.classList.add('active');

    const i = this.selectedEvents.indexOf(eventId);
    if (i > -1)
      this.selectedEvents.splice(i, 1);
    else
      this.selectedEvents.push(eventId);

    this.isDisabled = false;

    this.cdRef.markForCheck();
  }

  showEvent(eventId: string, type: boolean): boolean {
    // unselected tracks
    if (!type)
      if (!this.listOfFavorites.includes(eventId)) return true;
    // favorite tracks
    else
      if (this.listOfFavorites.includes(eventId)) return true;

    return false;
  }

  async showAlertMessage(message: string): Promise<void> {
    const alert = await this.alertCtrl.create({
      header: 'Info',
      message: message,
      buttons: [
        {
          text: 'Cancel',
          role: 'cancel',
          handler: () => {
          }
        },
        {
          text: 'Yes',
          handler: () => {
            this.ngZone.run(()=>{
              this.doClearFavoriteEvents();
            });
          }
        }
      ]
    });

    await alert.present();
  }

}
